/* Leather Plus FAQ for Shopify Dawn. Scoped and theme-editor safe. */
(function () {
  function normalize(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function initLeatherPlusFAQ(root) {
    if (!root || root.dataset.lpdawnFaqInitialized === 'true') return;
    root.dataset.lpdawnFaqInitialized = 'true';

    var search = root.querySelector('[data-faq-search]');
    var buttons = root.querySelectorAll('[data-faq-filter]');
    var empty = root.querySelector('[data-faq-empty]');
    var active = 'all';

    function applyFilters() {
      var query = normalize(search && search.value);
      var anyVisible = false;

      root.querySelectorAll('[data-faq-section]').forEach(function (section) {
        var sectionHasVisible = false;

        section.querySelectorAll('[data-faq-item]').forEach(function (item) {
          var matchesCategory = active === 'all' || item.getAttribute('data-category') === active;
          var matchesSearch = !query || normalize(item.getAttribute('data-search')).indexOf(query) > -1;
          var show = matchesCategory && matchesSearch;

          item.hidden = !show;
          if (show) sectionHasVisible = true;
        });

        section.hidden = !sectionHasVisible;
        if (sectionHasVisible) anyVisible = true;
      });

      if (empty) empty.hidden = anyVisible;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        active = button.getAttribute('data-faq-filter') || 'all';
        buttons.forEach(function (btn) {
          btn.setAttribute('aria-pressed', btn === button ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    if (search) search.addEventListener('input', applyFilters);
    applyFilters();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lpdawn-faq-root]').forEach(initLeatherPlusFAQ);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
